import {Transaksi} from './transaksi';
import {Parser} from 'xml2js';
import * as moment from 'moment';

export class FakturPajak {
   kode_jenis_transaksi: string;
   fg_pengganti: string;
   nomor_faktur: string;
   tanggal_faktur: Date;
   npwp_penjual: string;
   alamat_penjual: string;
   masa_pajak: number;
   tahun_pajak: number;
   nama_penjual: string;
   npwp_lawan_transaksi: string;
   nama_lawan_transaksi: string;
   alamat_lawan_transaksi: string;
   jumlah_dpp: number;
   jumlah_ppn: number;
   jumlah_ppnbm: number;
   status_approval: string;
   status_faktur: string;
   referensi: string;
   detail_transaksi: Transaksi[];

   static getFakturPajakFromJson(object: any): FakturPajak {
        const fp = new FakturPajak();
        if (object.faktur_pajak) {
            object = object.faktur_pajak;
        }
        fp.kode_jenis_transaksi = object.kdJenisTransaksi;
        fp.fg_pengganti = object.fgPengganti;
        fp.nomor_faktur = object.nomorFaktur;
        fp.npwp_penjual = object.npwpPenjual;
        fp.nama_penjual = object.namaPenjual;
        fp.alamat_penjual = object.alamatPenjual;
        fp.npwp_lawan_transaksi = object.npwpLawanTransaksi;
        fp.nama_lawan_transaksi = object.namaLawanTransaksi;
        fp.alamat_lawan_transaksi = object.alamatLawanTransaksi;
        fp.jumlah_dpp = Number(object.jumlahDpp);
        fp.jumlah_ppn = Number(object.jumlahPpn);
        fp.jumlah_ppnbm = Number(object.jumlahPpnBm);
        fp.status_approval = object.statusApproval;
        fp.status_faktur = object.statusFaktur;
        fp.referensi = object.referensi;
        fp.tanggal_faktur = moment(object.tanggalFaktur, 'DD/MM/YYYY').toDate();
        fp.masa_pajak = fp.tanggal_faktur.getMonth() + 1;
        fp.tahun_pajak = fp.tanggal_faktur.getFullYear();
        if (object.detailTransaksi instanceof Array) {
            fp.detail_transaksi = new Array<Transaksi>();
            for (const d of object.detailTransaksi) {
                const t = new Transaksi();
                t.nama_barang = d.nama;
                t.harga_satuan = Number(d.hargaSatuan);
                t.jumlah_barang = Number(d.jumlahBarang);
                t.harga_total = Number(d.hargaTotal);
                t.diskon = Number(d.diskon);
                t.dpp = Number(d.dpp);
                t.ppn = Number(d.ppn);
                t.tarif_ppnbm = Number(d.tarifPpnbm);
                t.ppnbm = Number(d.ppnbm);
                fp.detail_transaksi.push(t);
            }
        }
        return fp;
   }

   getFormattedDate(): string {
        return moment(this.tanggal_faktur).format('DD/MM/YYYY');
    }

    getPeriodePajak(): string {
        const periode = this.masa_pajak + '/' + this.tahun_pajak;
        return periode;
    }

    getStatusApproval(): boolean {
        if (this.status_approval === 'Faktur Valid, Sudah Diapprove oleh DJP') {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/faktur-pajak.ts